import { useQuery } from '@apollo/client';
import * as R from 'ramda';
import { useState } from 'react';
import { useParams } from 'react-router';
import invariant from 'tiny-invariant';
import { ApolloProviderV4 } from '~/apollo/client-v4';
import { graphql } from '~/apollo/generated/v4';
import { NoItemsAlert } from '~/components/common/NoItemsAlert';
import { NotFound } from '~/components/common/NotFound';
import { SpinnerPlaceholder } from '~/components/common/SpinnerPlaceholder';
import { ControlledCollapsibleCard } from '~/components/ui/collapse';
import { CreateVideoForm } from '~/components/upload/supporting-object/video/create-video-form';
import { VideoItems } from '~/components/upload/supporting-object/video/video-items';
import { createRefetchQueries } from '~/utils/graphql';

const UPLOAD_OUTCROP_VIDEOS_PAGE = graphql(`
  query UploadOutcropVideosPage($id: ID!) {
    outcropGet(id: $id) {
      id
      videos {
        ...videoParts
        placement {
          id
        }
      }
    }
  }
`);

export default function UploadOutcropVideosPage() {
  return (
    <ApolloProviderV4>
      <PageInner />
    </ApolloProviderV4>
  );
}

function PageInner() {
  const params = useParams();
  invariant(params.outcropId);
  const outcropId = parseInt(params.outcropId);

  const [isCreating, setIsCreating] = useState(false);

  const queryVars = { id: outcropId };

  const { data, loading } = useQuery(UPLOAD_OUTCROP_VIDEOS_PAGE, {
    variables: queryVars,
  });

  const refetchQueries = createRefetchQueries([
    { query: UPLOAD_OUTCROP_VIDEOS_PAGE, variables: queryVars },
  ]);

  const outcrop = data?.outcropGet;
  const videos = R.sortBy(v => v.name, outcrop?.videos ?? []);

  if (loading) return <SpinnerPlaceholder />;
  if (!outcrop) return <NotFound />;

  return (
    <div className="space-y-4">
      <ControlledCollapsibleCard
        open={isCreating}
        onToggle={() => setIsCreating(!isCreating)}
        title="Create Video"
      >
        <CreateVideoForm
          outcropId={outcropId}
          refetchQueries={refetchQueries}
          onCreateSuccess={() => setIsCreating(false)}
        />
      </ControlledCollapsibleCard>

      <NoItemsAlert show={!videos.length} entity="videos" />
      <VideoItems videos={videos} refetchQueries={refetchQueries} />
    </div>
  );
}
